module.exports = __webpack_public_path__ + "assets/about-annexum.d8c2e98f.svg";